import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  tableCellNoPadding: {
    padding: '0px',
  },
}));
